import { FormEditor } from './../../models/editors/form-editor.base.model';

export class Textbox extends FormEditor<string> {
    controlType = 'textbox';
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || 'text';
    }
}
